(function () {
  'use strict';

  function resolveAlt(img) {
    if (!img || img.getAttribute('alt') != null) return;

    var title = img.getAttribute('title');
    if (title) {
      img.setAttribute('alt', title);
      return;
    }

    if (img.closest('[aria-label], a[aria-label], button[aria-label]')) {
      img.setAttribute('alt', '');
      return;
    }

    img.setAttribute('alt', '');
  }

  function ensureImageAlts(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.tagName === 'IMG') {
      resolveAlt(root);
    }

    if (typeof root.querySelectorAll !== 'function') return;

    root.querySelectorAll('img:not([alt])').forEach(resolveAlt);
  }

  function init() {
    ensureImageAlts(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    ensureImageAlts(event.target);
  });

  if (typeof MutationObserver !== 'undefined') {
    var pending = false;

    var observer = new MutationObserver(function (mutations) {
      if (pending) return;
      pending = true;

      window.requestAnimationFrame(function () {
        pending = false;

        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            ensureImageAlts(node);
          });
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
